import React from "react"
import { Col, Row } from "react-bootstrap"
import { useSelector } from "react-redux"

import { ReservedFields } from "@/onboarding/features/product/models/Product"
import Field from "@/onboarding/features/product/components/shared/Field"
import {
  templatePrimaryDocumentFieldRenders,
  templatePrimaryFieldRenders,
} from "@/onboarding/features/product/selectors"

const Content = (): JSX.Element => {
  const hasTimeOfDay = useSelector(templatePrimaryDocumentFieldRenders("time_of_day"))
  const hasEveningExcursion = useSelector(templatePrimaryFieldRenders("evening_excursion"))

  return (
    <div className="d-flex flex-column gap-3">
      <Row>
        <Col md={3}>
          <Field name={ReservedFields.TARGET_MINIMUM_DEPARTURE_PAX} label="Minimum Per Departure" />
        </Col>
        <Col md={3}>
          <Field name={ReservedFields.TARGET_MAXIMUM_DEPARTURE_PAX} label="Maximum Per Departure" />
        </Col>
        <Col md={3}>
          <Field name={ReservedFields.TARGET_MAXIMUM_CALL_PAX} label="Maximum Per Call" />
        </Col>
        {hasTimeOfDay && (
          <Col md={3}>
            <Field name={ReservedFields.TIME_OF_DAY} label="Time of Day" />
          </Col>
        )}
        <Col hidden>
          <Field name={ReservedFields.TARGET_DEPARTURES} label="Departures" />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <Field name={ReservedFields.TOUR_TYPE} label="Tour Types" />
        </Col>
        <Col md={3}>
          <Field name={ReservedFields.ACTIVITY_TYPE} label="Activity Type" />
        </Col>
        <Col md={3}>
          <Field name={ReservedFields.ACTIVITY_LEVEL} label="Activity Level" />
        </Col>
      </Row>
      <Row>
        <Col>
          <Field name={ReservedFields.SHORT_TOUR_DESCRIPTION} label="Short Tour Description" />
        </Col>
      </Row>
      <Row>
        <Col>
          <Field name={ReservedFields.TOUR_DESCRIPTION} label="Full Tour Description" />
        </Col>
      </Row>
      <Row>
        <Col>
          <Field name={ReservedFields.TOUR_NOTES} label="Tour Notes" />
        </Col>
      </Row>
      <Row>
        <Col>
          <Field
            name={ReservedFields.TOP_THREE_REASONS}
            label="Top Three Reasons A Guest Should Buy This Tour"
          />
        </Col>
        <Col>
          <Field
            name={ReservedFields.CANCELLATION_POLICY_DESCRIPTION}
            label="Cancellation Policy"
          />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Field
            name={ReservedFields.UNAVAILABLE_DAYS}
            label="Days On Which The Tour Will Be Unavailable"
          />
        </Col>
        <Col md={6}>
          <Field
            name={ReservedFields.OTHER_RELEVANT_UNAVAILABLE_INFORMATION}
            label="Other Relevant Information On Days And Times The Tour Is Unavailable"
          />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Field name={ReservedFields.GROUND_OPERATOR} label="Ground Operator" />
        </Col>
        {hasEveningExcursion && (
          <Col md={3}>
            <Field name={ReservedFields.EVENING_EXCURSION} label="Evening Excursion?" />
          </Col>
        )}
        <Col md={3}>
          <Field name={ReservedFields.ADA_COMPLIANT} label="ADA Compliant" />
        </Col>
      </Row>
    </div>
  )
}

export default Content
